import * as types from './types';

const initialState = {
  coordinates: {
    lat: '',
    lng: ''
  },
  address: '',
  selectedProvince: '',
  selectedCity: '',
  selectedDistrict: '',
  selectedSubDistrict: '',
  locationInfo: '',
  errorCoordinates: false,
  provinceData: [],
  cityData: [],
  districtData: [],
  subDistrictData: [],
  isEdited: false,
  hasValues: false,
  visibility: 'EXACT',
  cep: '',
  cepError: false,
  loadingDistrict: false,
  addressComplement: ''
};

function step1Module2Reducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_COORDINATES:
      return { ...state, coordinates: { ...action.meta.coordinates }, errorCoordinates: false };
    case types.GET_COORDINATES_FAILED:
      return {
        ...state,
        errorCoordinates: true
      };
    case types.GET_COORDINATES_COMPLETED:
      return {
        ...state,
        locationInfo: action.payload,
        errorCoordinates: false
      };

    case types.GET_LOCATION:
      return {
        ...state,
        loadingDistrict: action.meta.locationName[0] === 'districtData' ? true : state.loadingDistrict
      };

    case types.GET_LOCATION_COMPLETED:
      return {
        ...state,
        [action.meta.locationName]: [...action.payload],
        loadingDistrict: action.meta.locationName[0] === 'districtData' ? false : state.loadingDistrict
      };

    case types.SET_ADDRESS:
      return {
        ...state,
        address: action.payload
      };

    case types.SET_SELECTED_PROVINCE: {
      let resetValues = {};
      if (action.payload.reset !== null) {
        resetValues = {
          selectedCity: '',
          selectedDistrict: '',
          selectedSubDistrict: '',
          cityData: [],
          districtData: [],
          subDistrictData: []
        };
      }
      return {
        ...state,
        ...resetValues,
        selectedProvince: action.payload.data,
        formValues: { ...state.formValues, selectedProvince: action.payload.data }
      };
    }
    case types.SET_SELECTED_CITY: {
      let resetValues = {};
      if (action.payload.reset !== null) {
        resetValues = {
          selectedDistrict: '',
          selectedSubDistrict: '',
          districtData: [],
          subDistrictData: []
        };
      }
      return {
        ...state,
        ...resetValues,
        selectedCity: action.payload.data,
        formValues: { ...state.formValues, selectedCity: action.payload.data }
      };
    }
    case types.SET_SELECTED_DISTRICT: {
      let resetValues = {};
      if (action.payload.reset !== null) {
        resetValues = {
          selectedSubDistrict: '',
          subDistrictData: []
        };
      }
      return {
        ...state,
        ...resetValues,
        selectedDistrict: action.payload.data,
        formValues: { ...state.formValues, selectedDistrict: action.payload.data }
      };
    }
    case types.SET_SELECTED_SUBDISTRICT:
      return { ...state, selectedSubDistrict: action.payload };

    case types.RESET_VALUES:
      return {
        ...state,
        selectedProvince: '',
        selectedCity: '',
        selectedDistrict: '',
        selectedSubDistrict: '',
        cityData: [],
        districtData: [],
        subDistrictData: []
      };

    case types.RESET_INFO:
      return {
        ...initialState
      };

    case types.SET_EDITED:
      return {
        ...state,
        isEdited: action.payload
      };

    case types.SAVE_STEP1_MODULE_2:
      return {
        ...state,
        formValues: { ...action.payload }
      };

    case types.SET_EDIT_VALUES: {
      let locations = {};
      const data = action.payload;
      switch (action.payload.depth) {
        case 1:
          locations = {
            idprovincia: data.location_id
          };
          break;
        case 2:
          locations = {
            idprovincia: data.parent.location_id,
            idciudad: data.location_id
          };
          break;
        case 3:
          locations = {
            idprovincia: data.parent.parent.location_id,
            idciudad: data.parent.location_id,
            idzonaciudad: data.location_id
          };
          break;
        case 4:
          locations = {
            idprovincia: data.parent.parent.parent.location_id,
            idciudad: data.parent.parent.location_id,
            idzonaciudad: data.parent.location_id,
            idsubzonaciudad: data.location_id
          };
          break;
        default:
      }
      return {
        ...state,
        hasValues: true,
        locationInfo: [locations]
      };
    }
    case types.GET_FORM_VALUES:
      return {
        ...state,
        isCompleted: false
      };
    case types.GET_FORM_VALUES_COMPLETED:
      return {
        ...state,
        isCompleted: true,
        hasLocation: action.payload.location,
        coordinates: { lat: action.payload.coordinates[0], lng: action.payload.coordinates[1] },
        address: action.payload.address,
        visibility: action.payload.geolocation_visibility ? action.payload.geolocation_visibility : 'EXACT',
        cep: action.payload.postal_code,
        addressComplement: action.payload.addressComplement ? action.payload.addressComplement : ''
      };

    case types.SET_VISIBILITY:
      return {
        ...state,
        visibility: action.payload
      };
    case types.SET_COORDINATES:
      return {
        ...state,
        coordinates: action.payload
      };
    case types.GET_CEP_COMPLETED:
      return {
        ...state,
        locationInfo: [action.payload],
        cepError: false
      };
    case types.GET_CEP_FAILED:
      return {
        ...state,
        cepError: true
      };
    case types.SET_CEP:
      return {
        ...state,
        cep: action.payload
      };
    case types.SET_ADDRESS_COMPLEMENT:
      return {
        ...state,
        addressComplement: action.payload
      };

    default:
      return state;
  }
}

export { step1Module2Reducer };
